import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import { SupabaseUploadFeedbackAttachmentRepository } from '@/modules/feedback/infra'
import type { UploadFeedbackAttachment } from '@/modules/feedback/use-cases'

export function makeUploadFeedbackAttachment(): UploadFeedbackAttachment {
  return new SupabaseUploadFeedbackAttachmentRepository(makeSupabaseEdgeHttpClient()).execute
}
